var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSemicircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 94,
    viewBox: "0 0 60 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 94,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1153_2894)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1445,
    y: -236,
    width: 1512,
    height: 982,
    rx: 10,
    fill: "url(#paint0_linear_1153_2894)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47888,
    d: "M57.2342 90.9154C45.9179 93.36 34.0727 91.4187 24.1098 85.4489C13.7172 79.2216 6.22404 69.121 3.2787 57.369C0.333353 45.617 2.17711 33.1763 8.40437 22.7837C14.3742 12.8207 23.9037 5.52243 35.0353 2.34106L57.2342 90.9154Z",
    fill: "#9B51E0",
    stroke: "#111111",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1153_2894",
    x1: -689,
    y1: -236,
    x2: -689,
    y2: 746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474002,
    stopColor: "#EAEDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D4E1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1153_2894"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1445,
    y: -236,
    width: 1512,
    height: 982,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemicircle);
export default __webpack_public_path__ + "static/media/Semicircle.d9af4a73807eba00adfa26ba346cfaa3.svg";
export { ForwardRef as ReactComponent };